// if thumbnail wrapper is present on the product page, continue
if (document.querySelectorAll('.thumbnail-wrapper').length > 0) {

  $(document).ready(function () {

    $(".thumbnail-wrapper .thumbnail").on('click touchend', function (e) {
      e.preventDefault();
      // console.log('clicked product thumbnail');
      // let clickedIndex = $(this).index();
      
      let clickedIndex = $(this).attr('data-slider-no');
      clickedIndex = clickedIndex - 1;
      
      if ($(".product-image .product-main-image").eq(clickedIndex)[0].querySelector('.video_overlap_text p')) document.querySelector(".best_seller_prd")?.classList.add('d_none');
      else document.querySelector(".best_seller_prd.d_none")?.classList.remove('d_none');

      $(".thumbnail-wrapper .thumbnail").removeClass('active');
      $(this).addClass('active');

      $(".product-image .product-main-image").addClass('hidden');
      $(".product-image .product-main-image").eq(clickedIndex).removeClass('hidden');
      
      const $video = $(".product-image .product-main-image").eq(clickedIndex).find('video');
      if ($video.closest('.product-main-image').hasClass("custom_prd_video")) {
        const prdVideoUrl = $video.attr('video__url');
        if (prdVideoUrl) {
          $video.find('source').attr('src', prdVideoUrl);
          $video[0].load();
          $video[0].play().catch(error => console.error('Error playing the video:', error));
        }
      }

    });

    $(window).scroll(function () {

      checkCounterScroll('stats');

    });
    // Hide scrollbar:

    // Get scroll bar element
    let elWithScrollbar = document.querySelector('.scroll-wrapper');
    let $elWithScrollbar = $(elWithScrollbar);

    function setScrollBarPadding() {
      // Get any padding on the scroll wrapper
      let productThumbnailsPaddingRight = parseInt($elWithScrollbar.css('padding-left'));

      // Calculate scrollbar width
      let elScrollBarOffset = elWithScrollbar.offsetWidth - elWithScrollbar.clientWidth;

      // Apply scrollbar width and padding as padding
      elWithScrollbar.style.paddingRight = productThumbnailsPaddingRight + elScrollBarOffset + 1 + "px";
    }

    let scrollAmount = 130 * 3;

    // Remember these so we don't have to keep querying
    let $arrowTop = $(".thumbnail-arrow-box.top");
    let $arrowBottom = $(".thumbnail-arrow-box.bottom");
    let $scrollBarLeft = $(".bundle_prd_ties,.design_v2");

    // When you click on the top arrow
    $arrowTop.on('click touchend', function (e) {
      // console.log('clicked scroll top');
      e.preventDefault();
      if ($scrollBarLeft.length > 0) {
        let currentScrollLeft = $elWithScrollbar.scrollLeft();
        $elWithScrollbar.scrollLeft(currentScrollLeft - scrollAmount);
      } else {
        let currentScrollTop = getScrollTop();
        $elWithScrollbar.scrollTop(currentScrollTop - scrollAmount);
      }

    });

    // When you click on the bottom arrow
    $arrowBottom.on('click touchend', function (e) {
      // console.log('clicked scroll bottom');
      e.preventDefault();

      console.log(' clicked');
      
      if ($scrollBarLeft.length > 0) {
        console.log(' left scroll');
        
        let currentScrollLeft = $elWithScrollbar.scrollLeft();
        $elWithScrollbar.scrollLeft(currentScrollLeft + scrollAmount);
      } else {
        console.log(' top scroll');
        
        let currentScrollTop = getScrollTop();
        $elWithScrollbar.scrollTop(currentScrollTop + scrollAmount);
      }

    });

    // When the element gets scrolled
    $elWithScrollbar.scroll(checkScrollPosition);
    $(window).resize(reinit);

    // Check if scroll positions are okay
    function checkScrollPosition() {
      let currentScroll = getScrollTop();
      checkScrollTop(currentScroll);
      checkScrollBottom(currentScroll);
    }

    // Returns current scrolltop of the scrollbar element
    function getScrollTop() {
      return $elWithScrollbar.scrollTop();
    }

    // Gets max scroll height of the scrollbar element
    function getMaxScrollHeight() {
      var trueDivHeight = $elWithScrollbar[0].scrollHeight;
      var divHeight = $elWithScrollbar.height();
      return ~~(trueDivHeight - divHeight);
    }

    // Check if we havn't reached the top
    function checkScrollTop(currentScroll) {
      if (currentScroll <= 0) {
        $arrowTop.addClass('hidden');
      } else {
        $arrowTop.removeClass('hidden');
      }
    }

    // Check if we havn't reached the top
    function checkScrollBottom(currentScroll) {
      if (currentScroll >= getMaxScrollHeight()) {
        $arrowBottom.addClass('hidden');
      } else {
        $arrowBottom.removeClass('hidden');
      }
    }

    // sort of initialize the scroll to make sure we don't show wrong arrows
    function reinit() {
      // console.log('reinit');
      checkScrollPosition();
      setScrollBarPadding();
    }

    reinit();

    $(window).on('load', function () {
      $('#desktop-instashop-container').addClass('loaded');
    });

    $('.flexslider').flexslider({
      animation: "slide",
    });
    $('[data-fancybox="gallery"]').fancybox({
      // Options will go here
      loop: true,
      buttons: [
        "close"
      ],
      transitionEffect: "slide",
      animationEffect: "fade",
      btnTpl: {
        close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
          '<div><i class="fas fa-times"></i></div>' +
          "</button>",
        // Arrows
        arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
          '<div><i class="fas fa-chevron-left"></i></div>' +
          "</button>",
        arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
          '<div><i class="fas fa-chevron-right"></i></div>' +
          "</button>"

      },
      mobile: {
        preventCaptionOverlap: false,
        idleTime: false,
        clickContent: function (current, event) {
          return "close";
        },
        clickSlide: function (current, event) {
          return "close";
        },
        dblclickContent: function (current, event) {
          return current.type === "image" ? "zoom" : false;
        },
        dblclickSlide: function (current, event) {
          return current.type === "image" ? "zoom" : false;
        }
      },
    });
  });

}